import React from 'react';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';

import { DecisionDialogPropTypes } from 'src/interfaces/iproptypes';
import {
  COLOR_PRIMARY,
  COLOR_RED_LIGHT,
  COLOR_RED,
  COLOR_GREEN_ACCENT_1,
  COLOR_GREEN,
} from 'src/utils/const';

const DecisionDialog = ({
  open,
  handleClose,
  title,
  descriptions,
  agreeButtonText,
  disagreeButtonText,
  onAgree,
  onDisagree,
}: DecisionDialogPropTypes) => {
  const onConfirmClick = () => {
    onAgree();
    handleClose();
  };

  const onCancelClick = () => {
    onDisagree && onDisagree();
    handleClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{
        '& .MuiDialog-paper': {
          padding: 2,
        },
      }}
    >
      <DialogTitle id="alert-dialog-title" sx={{ color: COLOR_PRIMARY }}>
        {title}
      </DialogTitle>
      <DialogContent>
        {descriptions.map(description => (
          <DialogContentText id="alert-dialog-description" sx={{ marginBottom: 2 }}>
            {description}
          </DialogContentText>
        ))}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onCancelClick}
          sx={{
            background: 'white',
            color: COLOR_RED_LIGHT,
            fontSize: '14px',
            textTransform: 'none',
            borderRadius: '5px',
            border: `1px solid ${COLOR_RED_LIGHT}`,
            '&:hover': {
              color: COLOR_RED,
              border: `1px solid ${COLOR_RED}`,
            },
          }}
        >
          {disagreeButtonText}
        </Button>
        <Button
          onClick={onConfirmClick}
          autoFocus
          sx={{
            background: COLOR_GREEN_ACCENT_1,
            color: 'white',
            fontSize: '14px',
            '&:hover': {
              background: COLOR_GREEN,
            },
            textTransform: 'none',
          }}
        >
          {agreeButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DecisionDialog;
